import { IMicrosite } from "../app/models/microsite";

const isVisit = window.location.hostname.toLowerCase().includes("visit");

export const microsites: IMicrosite[] = [
  {
    name: "Logger",
    entrypoint: "/logger",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/logger"
      : "https://console.fsp.intouchhealth.com/ui/logger",
    displayName: "Log Service",
  },
  {
    name: "Monitoring",
    entrypoint: "/monitoring",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/monitoring"
      : "https://console.fsp.intouchhealth.com/ui/monitoring",
    displayName: "Monitoring",
  },
  {
    name: "AccessManagement",
    entrypoint: "/access",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/access"
      : "https://console.fsp.intouchhealth.com/ui/access",
    displayName: "Access Management",
  },
  {
    name: "DeviceProvisioning",
    entrypoint: "/provisioning",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/provisioning"
      : "https://console.fsp.intouchhealth.com/ui/provisioning",
    displayName: "Device Provisioning",
  },
  {
    name: "PASProvisioning",
    entrypoint: "/pas-provisioning",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/pas-provisioning"
      : "https://console.fsp.intouchhealth.com/ui/pas-provisioning",
    displayName: "PAS Provisioning",
  },
  {
    name: "Updater",
    entrypoint: "/updater",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/updater"
      : "https://console.fsp.intouchhealth.com/ui/updater",
    displayName: "Updater",
  },
  {
    name: "AuxUpdater",
    entrypoint: "/auxupdater",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/auxupdater"
      : "https://console.fsp.intouchhealth.com/ui/auxupdater",
    displayName: "Aux Updater",
  },
  {
    name: "ITLLogViewer",
    entrypoint: "/itl-log-viewer",
    host: isVisit
      ? "https://hhsconsole.fsp.visitnow.org/ui/itl-log-viewer"
      : "https://console.fsp.intouchhealth.com/ui/itl-log-viewer",
    displayName: "ITL Log Viewer",
  },
];
